import { useRef, useEffect, useState } from "react";
import Select from "react-select";
import { Plus, Minus, Trash2, Info } from "lucide-react";
import {entradas,extrasH} from "./Utils/DescripcionesPlatos";
import { nanoid } from "nanoid";
import  { customStyles, ModalAnimado, } from "./Utils/CustomStyles";
import { showSuccess, showError, showInfo } from "./Utils/toastUtils";
import { persistirSeleccion, reemplazarProducto } from "./Utils/persistirSeleccion";
import { useItems } from "../Hooks/useItems";
import { FaTimes, FaPlus, FaMinus, FaChevronDown } from "react-icons/fa";
import { motion } from "framer-motion";
import { useSwipeable } from "react-swipeable";


const opcionesPlatos = Object.keys(entradas).map((item) => ({
  label: item,
  value: item,
}));

const PlatoSelectorEntradas = ({ onSeleccion = () => {}, editarProductoId = null, onCerrarEdicion, soloModal = false }) => {
   
  const [ingredientesSeleccionadosPorEntrada, setIngredientesSeleccionadosPorEntrada] = useState(() => {
  try {
    const stored = localStorage.getItem("ingredientesSeleccionadosPorEntrada");
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
  });
  const [tipoSeleccion, setTipoSeleccion] = useState("Sola");
  const [bebidaSeleccionada, setBebidaSeleccionada] = useState(null);
  const [proteinaSeleccion, setProteinaSeleccion] = useState("Carne")
  const [paginaActual, setPaginaActual] = useState(0);
const [extrasSeleccionados, setExtrasSeleccionados] = useState({});
const [ajusteEspacio, setAjusteEspacio] = useState(0);
// Estado: ingredientes que el usuario decide excluir
const [exclusiones, setExclusiones] = useState([]);
const [exclusionesAbierto, setExclusionesAbierto] = useState(false);
 const [loading, setLoading] = useState(true);
  const [imgsLoaded, setImgsLoaded] = useState(0);

  // Suponiendo que tenemos logo + la imagen principal del plato


const nombreRef = useRef(null);
const descRef = useRef(null);


  const [mostrarTip, setMostrarTip] = useState(false);

  
  const [modalDescripcionInfo, setModalDescripcionInfo] = useState(null);
  const [imagenAmpliada, setImagenAmpliada] = useState(false);
  const [tempuraFrioPorSabor, setTempuraFrioPorSabor] = useState({});
  const [platoTemporal, setPlatoTemporal] = useState(null);
  const [platoPendiente, setPlatoPendiente] = useState(null); // plato seleccionado del Select, aún no confirmado
  const { platosSeleccionados, setPlatosSeleccionados, aumentarCantidad, disminuirCantidad, eliminarItem } = useItems("entradasSeleccionadas");

 useEffect(() => {
  try {
    const arrayEntradas = platosSeleccionados.map((plato) => ({
      id: plato.id,
      nombre: plato.nombre,
      cantidad: plato.cantidad,
      precio: plato.precio,
      tipoSeleccion: plato.tipoSeleccion,
      bebida: plato.bebida,
      proteina: plato.proteina,
      extras: plato.extras || {}, // ✅ agrega esto
      exclusiones: plato.exclusiones,
    }));

    localStorage.setItem("entradasSeleccionadas", JSON.stringify(arrayEntradas));
    onSeleccion(platosSeleccionados);
  } catch (e) {
    console.error("Error guardando entradasSeleccionadas en localStorage", e);
  }
}, [platosSeleccionados, ingredientesSeleccionadosPorEntrada, tempuraFrioPorSabor, onSeleccion]);


  useEffect(() => {
  if (tipoSeleccion === "Sola") setBebidaSeleccionada(null);
}, [tipoSeleccion]);

useEffect(() => {
  if (platoTemporal && modalDescripcionInfo) {
    setPlatoTemporal(prev => ({
      ...prev,
      tipoSeleccion,
      bebida: tipoSeleccion === "Combo" ? bebidaSeleccionada : null,
      proteina: proteinaSeleccion,
    }));
  }
}, [tipoSeleccion, bebidaSeleccionada, proteinaSeleccion, modalDescripcionInfo]);

useEffect(() => {
  if (nombreRef.current && descRef.current) {
    const nombreRect = nombreRef.current.getBoundingClientRect();
    const descRect = descRef.current.getBoundingClientRect();
    const espacio = descRect.top - nombreRect.bottom;

    const ESPACIO_MINIMO = 8; // px que consideras "aceptable"
    if (espacio > ESPACIO_MINIMO) {
      setAjusteEspacio(espacio - ESPACIO_MINIMO);
    } else {
      setAjusteEspacio(0);
    }
  }
}, [modalDescripcionInfo]);


useEffect(() => {
  const yaMostrado = sessionStorage.getItem("tipModificacionMostrado");
  if (yaMostrado) setMostrarTip(false);
}, []);

  const totalImages = 1 + (modalDescripcionInfo ? 1 : 0);


useEffect(() => {
  setLoading(true);
  setImgsLoaded(0);
  const t = setTimeout(() => setLoading(false), 800);
  return () => clearTimeout(t);
}, [modalDescripcionInfo]);

// Cuando se cargan todas las imágenes, ocultamos el loading
useEffect(() => {
  if (imgsLoaded >= totalImages) {
    setLoading(false);
  }
}, [imgsLoaded, totalImages]);

// Función que llamamos en cada <img> cuando termina de cargar
const handleImageLoad = () => {
  setImgsLoaded(prev => prev + 1);
  setLoading(false)
};





const mostrarModalAyuda = () => {
  setMostrarTip(true);
  sessionStorage.setItem("tipModificacionMostrado", "true");

  // Ocultarlo automáticamente después de unos segundos (opcional)
  setTimeout(() => setMostrarTip(false), 5000);
};

const abrirEdicion = (plato) => {
  const disponible = entradas[plato.nombre]?.disponible;
  if (!disponible) {
    showInfo && showInfo("Este producto no está disponible");
    return;
  }
  setModalDescripcionInfo({ nombre: plato.nombre, id: plato.id });
  setPlatoTemporal(plato);
  setPaginaActual(0);
  setTipoSeleccion(plato.tipoSeleccion || "Sola");
  setBebidaSeleccionada(plato.bebida || null);
  setProteinaSeleccion(plato.proteina || "Carne");
  setExclusiones(Array.isArray(plato.exclusiones) ? [...plato.exclusiones] : []);
  if (plato.extras) {
    setExtrasSeleccionados(
      Object.keys(plato.extras).reduce((acc, key) => {
        acc[key] = { cantidad: plato.extras[key].cantidad };
        return acc;
      }, {})
    );
  } else {
    setExtrasSeleccionados({});
  }
};

useEffect(() => {
  if (!editarProductoId) return;
  const plato = platosSeleccionados.find((p) => p.id === editarProductoId);
  if (plato) abrirEdicion(plato);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [editarProductoId]);

 const cambiarCantidadExtra = (extra, cantidad) => {
  setExtrasSeleccionados(prev => {
    const actual = prev[extra]?.cantidad || 0;
    const nuevaCantidad = Math.max(0, actual + cantidad); // nunca negativo
    return {
      ...prev,
      [extra]: { cantidad: nuevaCantidad }
    };
  });
};

 const agregarOActualizarPlato = (platoNombre) => {
  
 
     const precioS = parseFloat(entradas[platoNombre]?.precioS || 0);
     const precioC = parseFloat(entradas[platoNombre]?.precioC || 0);
     const nuevoId = nanoid();
 
     // Crear plato temporal
     setPlatoTemporal({
       id: nuevoId,
       nombre: platoNombre,
       cantidad: 1,
       tipoSeleccion: "Sola",
       bebida: null,
       extras: {},
       precio: precioS,
       exclusiones: [],
     });
 
     // Inicializar estados del modal
     setPlatoPendiente(platoNombre);
     setModalDescripcionInfo({
       nombre: platoNombre,
       id: nuevoId,
     });
 
     setPaginaActual(0);
 
     // Resetear selección del modal
     setTipoSeleccion("Sola");
     setBebidaSeleccionada(null);
     setProteinaSeleccion("Carne");
     setExtrasSeleccionados({});
     setExclusiones([]);  // limpiar exclusiones luego de cerrar

   
 };

   
    const cerrarModal = () => {
      if (!modalDescripcionInfo || !platoTemporal) return;
    
      const nombre = modalDescripcionInfo.nombre;
      const platoId = modalDescripcionInfo.id;
    
      // Validar bebida si es combo
      if (tipoSeleccion === "Combo" && !bebidaSeleccionada) {
        showError("Debes elegir una bebida para el combo.");
        return;
      }
    
      // Calcular precio base según tipo
      const precioBase =
        tipoSeleccion === "Combo"
          ? parseFloat(entradas[nombre]?.precioC || 0)
          : parseFloat(entradas[nombre]?.precioS || 0);
    
      // Calcular total de extras
      const extras = Object.keys(extrasSeleccionados).reduce((acc, extra) => {
        const cantidad = extrasSeleccionados[extra]?.cantidad || 0;
        if (cantidad > 0) {
          acc[extra] = {
            cantidad,
            precioUnitario: parseFloat(extrasH[extra].precio),
            subtotal: cantidad * parseFloat(extrasH[extra].precio),
          };
        }
        return acc;
      }, {});
    
      const totalExtras = Object.values(extras).reduce(
        (sum, e) => sum + e.subtotal,
        0
      );
    
      const platoActualizado = {
        ...platoTemporal,
        tipoSeleccion,
        bebida: tipoSeleccion === "Combo" ? bebidaSeleccionada : null,
        proteina: proteinaSeleccion,
        extras,
        precio: precioBase,
        exclusiones: exclusiones,
      };

      const platosGuardados = reemplazarProducto(platosSeleccionados, platoActualizado);
      persistirSeleccion("entradasSeleccionadas", platosGuardados, onSeleccion);
      setPlatosSeleccionados(platosGuardados);

      try {
        sessionStorage.setItem("entradasSeleccionadas", JSON.stringify(platosGuardados));
      } catch (e) {}

      showSuccess(tipoSeleccion === "Combo" ? "Combo actualizado" : "Plato actualizado");

      setModalDescripcionInfo(null);
      setPlatoPendiente(null);
      setPlatoTemporal(null);
      setBebidaSeleccionada(null);
      setTipoSeleccion("Sola");
      setExtrasSeleccionados({});
      setExclusiones([]);
      onCerrarEdicion?.();

      const yaMostrado = sessionStorage.getItem("tipModificacionMostrado");
if (!yaMostrado && !soloModal) {
  setTimeout(() => {
    mostrarModalAyuda();
  }, 2000);
}
    };
    
  
    const forzarCerrarModal = () => {
      setModalDescripcionInfo(null);
      onCerrarEdicion?.();
    };

    const precioTotal = () => {
      if (!modalDescripcionInfo) return 0;
    
      // precio base según tipo
      const base =
        tipoSeleccion === "Sola"
          ? parseFloat(entradas[modalDescripcionInfo.nombre].precioS)
          : parseFloat(entradas[modalDescripcionInfo.nombre].precioC);
    
      // suma extras
      const totalExtras = Object.keys(extrasSeleccionados).reduce((acc, extra) => {
        const cantidad = extrasSeleccionados[extra]?.cantidad || 0;
        const precioExtra = parseFloat(extrasH[extra].precio);
        return acc + precioExtra * cantidad;
      }, 0);
    
      return (base + totalExtras).toFixed(2);
    };

    const swipeHandlers = useSwipeable({
      onSwipedLeft: () => paginaActual < 1 && setPaginaActual(paginaActual + 1),
      onSwipedRight: () => paginaActual > 0 && setPaginaActual(paginaActual - 1),
      trackMouse: true,
    });

   const toggleExclusion = (ingrediente) => {
  setExclusiones((prev) =>
    prev.includes(ingrediente)
      ? prev.filter((i) => i !== ingrediente)
      : [...prev, ingrediente]
  );
};

  return (
  <div className={soloModal ? "" : "max-w-xl mx-auto mb-3"}>
    {!soloModal && (
    <>
    <Select
      options={opcionesPlatos}
      styles={customStyles}
      placeholder="Selecciona un Hot Dog"
      onChange={(opt) => agregarOActualizarPlato(opt.value)}
      menuPlacement="auto"
    />

    <div className="space-y-4 mt-4">
  {platosSeleccionados.map((plato) => {

    return (
      <div
        key={plato.id}
        className="relative rounded-lg overflow-hidden shadow-md"
      >
        {/* Imagen de fondo */}
        <div
          className="absolute inset-0 bg-center bg-contain bg-no-repeat"
  style={{
    backgroundImage: `url(${entradas[plato.nombre]?.productoImg})`,
    backgroundSize: "120%",
  }}
        />

        {/* Overlay oscuro */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Contenido sobre la imagen */}
        <div className="relative p-4 space-y-2 text-white">
          {/* Nombre + Botón info */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <h3 className="font-extrabold text-xl flex items-center justify-between sm:justify-start">
              {plato.nombre}
             <button
              onClick={() => abrirEdicion(plato)}
             
                           className="ml-2 text-white hover:text-gray-300"
                         >
                           <Info size={18} />
                         </button>
            {mostrarTip && (
  <div
    style={{
      position: "absolute", // relativo a la tarjeta
      top: "70%",           // centrar vertical
      left: "50%",          // centrar horizontal
      transform: "translate(-5%, -60%)", // verdadero centro
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      background: "rgba(0, 0, 0, 0.35)",
      color: "#fff",
      padding: "10px 14px",
      borderRadius: "12px",
      fontSize: "14px",
      maxWidth: "220px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      zIndex: 999999,
      textAlign: "center",
      animation: "fadeIn 0.4s ease",
      pointerEvents: "none",
    }}
  >
    ¡Modifica tu pedido tocando este ícono!

    {/* Flecha apuntando al botón */}
    <div
      style={{
        position: "absolute",
        top: "-8px", // poner justo encima del tip
        right: "10px", // ajustar según la posición del botón info
        width: 0,
        height: 0,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: "8px solid rgba(0,0,0,0.35)", // flecha apuntando arriba
        filter: "blur(0.3px)",
      }}
    />
  </div>
)}

            </h3>

            {/* Botones cantidad y eliminar */}
            <div className="flex items-center justify-center space-x-2 mt-2 sm:mt-0">
              <button
                onClick={() => disminuirCantidad(plato.id, showSuccess)}
                className="p-1 hover:text-gray-200"
              >
                <Minus size={18} />
              </button>
              <button
                onClick={() => aumentarCantidad(plato.id, showSuccess)}
                className="p-1 hover:text-gray-200"
              >
                <Plus size={18} />
              </button>
              <button
                onClick={() => eliminarItem(plato.id, showSuccess)}
                className="p-1 text-white hover:text-red-800"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>

          {/* Cantidad */}
          <p className="text-sm mt-2 text-center">Cantidad: {plato.cantidad}</p>

          
{/* Contenedor inferior de la tarjeta */}
<div className="flex justify-end mt-3">
  <span
    className={`px-5 py-2 rounded-full text-sm font-semibold shadow-md
      ${plato.tipoSeleccion === "Combo" ? "bg-yellow-400 text-black" : "bg-yellow-400 text-black"}`}
    style={{ minWidth: "60px", textAlign: "center" }}
  >
    {plato.tipoSeleccion}
  </span>
</div>


        </div>
      </div>
    );
  })}
</div>
    </>
    )}

 <ModalAnimado isOpen={!!modalDescripcionInfo} onClose={cerrarModal}>
  
    <div className="relative z-10 flex flex-col h-full">

      {/* Botón cerrar */}
      <button
        onClick={forzarCerrarModal}
        className="absolute top-1 right-1 z-50 bg-neutral-400 hover:bg-white/50 transition rounded-xl w-9 h-9 flex items-center justify-center text-xl text-white/80 font-bold"
      >
        <FaTimes className="text-white text-2xl " />
      </button>

      {/* Contenedor general */}
      <div className="flex-1 flex flex-col relative">

        {/* Contenido deslizable */}
        <div className="flex-1 overflow-hidden relative">
          {(() => {
            
            return (
              <motion.div
                {...swipeHandlers}
                key={paginaActual}
                initial={{ x: paginaActual === 0 ? 300 : -300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: paginaActual === 0 ? -300 : 300, opacity: 0 }}
                transition={{ type: "spring", stiffness: 260, damping: 25 }}
                className="h-full flex flex-col"
              >
                 {loading && paginaActual === 0 && (
                            <motion.div
                              key="loader"
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              className="absolute inset-0 flex flex-col items-center justify-center z-50 rounded-2xl"
                            >
                              <div className="w-16 h-16 border-4 border-neutral-500 border-t-transparent rounded-full animate-spin"></div>
                            </motion.div>
                          )}

                {/* === Página 0: Contenido principal === */}
                {paginaActual === 0 && (
                  <div className={`flex-1 overflow-y-auto px-5 pt-2 pb-7 ${loading ? "pointer-events-none select-none opacity-0" : "opacity-100 transition-opacity duration-500"}`}>
  {/* Imagen + nombre (fijos) */}
  <div className="relative w-full flex justify-center ">
    <img
      src={entradas[modalDescripcionInfo?.nombre]?.productoImg}
      alt={modalDescripcionInfo?.nombre}
      className="object-contain drop-shadow-lg rounded-lg"
      style={{
        maxHeight: `${entradas[modalDescripcionInfo?.nombre]?.altoImg}px`,
        maxWidth: `${entradas[modalDescripcionInfo?.nombre]?.anchoImg}px`,
        marginTop: `-${entradas[modalDescripcionInfo?.nombre]?.marginTop}px`
      }}
       onLoad={handleImageLoad}

    />
    <div
      className="absolute w-auto text-center py-1 rounded-r-xl"
      style={{
        bottom: `${entradas[modalDescripcionInfo?.nombre]?.bottom}px`
      }}
    >
      <h2 
      ref={nombreRef}
      className="text-2xl sm:text-3xl font-extrabold uppercase text-yellow-400 drop-shadow-lg">
        {modalDescripcionInfo?.nombre}
      </h2>
    </div>
  </div>

  {/* Contenedor flexible para todo lo demás */}
  <div className="flex flex-col gap-4 ">
    {/* Descripción */}
    {entradas[modalDescripcionInfo?.nombre]?.descripcion && (
      <p
    ref={descRef}
    className="text-base leading-snug tracking-wide text-gray-400 uppercase font-semibold text-center drop-shadow-sm"
    style={{
      marginTop: `-${ajusteEspacio}px` // ajusta hacia arriba si hay demasiado espacio
    }}
  >
    {entradas[modalDescripcionInfo?.nombre]?.descripcion}
  </p>
    )}

    {/* Selección proteína + tipo */}
    <div className="flex flex-wrap justify-center gap-2">
      {entradas[modalDescripcionInfo?.nombre]?.polloOCarne && (
        <div className="flex flex-wrap justify-center gap-2 bg-black/30 backdrop-blur-xl rounded-full p-1 shadow-[0_2px_10px_rgba(0,0,0,0.5)] border border-white/10">
          {["Carne", "Pollo"].map((opcion) => (
            <button
              key={opcion}
              onClick={() => setProteinaSeleccion(opcion)}
              className={`px-4 py-2 rounded-full font-extrabold text-sm sm:text-base transition-all
                ${proteinaSeleccion === opcion
                  ? "bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 text-white shadow-lg scale-105"
                  : "bg-transparent text-white/80 hover:text-white hover:bg-white/10"
                }`}
            >
              {opcion}
            </button>
          ))}
        </div>
      )}

      <div className="flex flex-wrap justify-center gap-2 bg-black/30 backdrop-blur-xl rounded-full p-1 shadow-[0_2px_10px_rgba(0,0,0,0.5)] border border-white/10">
        {["Sola", "Combo"].map((tipo) => (
          <button
            key={tipo}
            onClick={() => setTipoSeleccion(tipo)}
            className={`px-4 py-2 rounded-full font-extrabold text-sm sm:text-base transition-all
              ${tipoSeleccion === tipo
                ? "bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 text-white shadow-lg scale-105"
                : "bg-transparent text-white/80 hover:text-white hover:bg-white/10"
              }`}
          >
            {tipo}
          </button>
        ))}
      </div>
    </div>

    {/* Selección bebida */}
    {tipoSeleccion === "Combo" && (
      <div className="flex flex-wrap justify-center gap-4">
        {entradas[modalDescripcionInfo?.nombre]?.bebida?.map((b, idx) => (
          <button
            key={idx}
            onClick={() => setBebidaSeleccionada(b)}
            className={`px-5 py-2 rounded-full font-medium text-sm transition-all duration-300
              border-2 ${bebidaSeleccionada === b
                ? "bg-yellow-400 text-black border-yellow-400 shadow-lg scale-105"
                : "bg-white text-gray-600 border-gray-200 hover:bg-yellow-50 hover:border-yellow-300"
              }`}
          >
            {b}
          </button>
        ))}
      </div>
    )}
         {/* ACCORDION DE EXCLUSIONES */}
    <div className="w-full mt-4 mb-3 bg-[#f5f5f5] rounded-xl shadow-sm pb-2">
    
      {/* Header del accordion */}
      <div
        className="flex justify-between items-center py-3 px-4   active:scale-[0.98] transition-all cursor-pointer"
        onClick={() => setExclusionesAbierto(!exclusionesAbierto)}
      >
        <p className=" text-gray-400 font-bold ">
          ¿Deseas excluir algo de tu plato?
        </p>
    
        <FaChevronDown
          className={`text-neutral-400 text-xl transition-transform duration-300 ${
            exclusionesAbierto ? "rotate-180" : ""
          }`}
        />
      </div>
    
      {/* Contenido */}
      {exclusionesAbierto && (
        <div className="mt-3 px-4 pb-1 flex flex-col gap-3">
    
          {entradas[modalDescripcionInfo?.nombre]?.ingredientes?.map((ing, i) => (
      <label key={i} className="flex items-center gap-3 cursor-pointer select-none">
      <div
        onClick={() => toggleExclusion(ing)}
        className={`w-6 h-6 flex items-center justify-center rounded-md border transition-all 
          ${exclusiones.includes(ing)
            ? "bg-neutral-500"
            : "border-gray-300 bg-white"
          }`}
      >
        {exclusiones.includes(ing) && (
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            viewBox="0 0 24 24"
          >
            <path d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
    
      <span className="text-neutral-500 font-bold text-base">Sin {ing}</span>
    </label>
    
    ))}
    
    
        </div>
      )}
    
    </div>

    <strong className="text-gray-400 font-bold text-center">¿Deseas agregar un extra? Desliza!</strong>
  </div>
</div>

                )}

               {/* === Página 1: Extras === */}
{paginaActual === 1 && (
  <div className="flex-1 overflow-y-auto max-h-[450px] mt-10 px-1 space-y-3">
    <h1 className=" flex font-extrabold text-yellow-500 uppercase text-2xl" >Extras</h1>
    {Object.keys(extrasH).map((extra) => (
      <div key={extra} className="flex justify-between items-center bg-white/80 border border-neutral-200 p-3 rounded-xl">
       <div className="flex flex-col items-start">
  <h4 className="font-extrabold text-yellow-500 uppercase">{extra}</h4>
  <p className="text-neutral-400 font-extrabold mt-1">${extrasH[extra].precio}</p>
</div>

        <div className="flex items-center gap-4">
          <button 
          className="border border-yellow-400 rounded-full py-2 px-2" 
          onClick={() => {
    cambiarCantidadExtra(extra, -1); // aumenta la cantidad
    showInfo(`Se eliminó ${extra}`); // mensaje de info
  }}>
  <FaMinus className="text-yellow-400" />
</button>
<span className="text-neutral-400">{extrasSeleccionados[extra]?.cantidad || 0}</span>
<button  
className="border border-yellow-400 rounded-full py-2 px-2"  
onClick={() => {
    cambiarCantidadExtra(extra, 1); // aumenta la cantidad
    showSuccess(`Se agregó ${extra}`); // mensaje de éxito
  }}>
  <FaPlus className="text-yellow-400" />
</button>

        </div>
      </div>
    ))}
  </div>
)}


              </motion.div>
            )
          })()}

          {/* Indicadores tipo círculos */}
          <div className="absolute bottom-1 w-full flex justify-center gap-2">
            
            {[0,1].map((num) => (
              <span
                key={num}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer
                  ${paginaActual === num ? "bg-yellow-400 scale-125" : "bg-gray-400"}`}
                onClick={() => setPaginaActual(num)}
              />
            ))}
           
          </div>
                              
                              


        </div>


        {/* Footer: precio dinámico y agregar */}
        <div className="w-full flex justify-between items-center py-4 mt-3 px-5">
          <span className="text-2xl font-extrabold text-yellow-400 drop-shadow-md">
            ${precioTotal()}
          </span>
          <button
            onClick={cerrarModal}
            className="px-6 py-2 bg-yellow-500 shadow-xl text-lg text-white font-extrabold rounded-xl"
          >
            {soloModal ? "Guardar" : "Agregar"}
          </button>
        </div>

      </div>
    </div>
  
</ModalAnimado>



  </div>
  );


};

export default PlatoSelectorEntradas;

